module.exports = __webpack_public_path__ + "img/bg-ellipse-1.21fb0254.svg";